// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Call recording player (Outreach tab detail, Call Experience call info). */
.recording-player-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.recording-player {
  width: 100%;
  max-width: 420px;
  height: 40px;
}

.load-recording-button {
  align-self: flex-start;
  padding: 6px 14px;
  background: var(--wellsky-indigo);
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
}

.load-recording-button:disabled {
  opacity: 0.6;
  cursor: default;
}

.recording-error {
  margin: 0;
  color: #c62828;
  font-size: 13px;
}

.recording-sid {
  margin: 0;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/RecordingPlayer.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB","sourcesContent":["/* Call recording player (Outreach tab detail, Call Experience call info). */\n.recording-player-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.recording-player {\n  width: 100%;\n  max-width: 420px;\n  height: 40px;\n}\n\n.load-recording-button {\n  align-self: flex-start;\n  padding: 6px 14px;\n  background: var(--wellsky-indigo);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.load-recording-button:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.recording-error {\n  margin: 0;\n  color: #c62828;\n  font-size: 13px;\n}\n\n.recording-sid {\n  margin: 0;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
